module.exports = __webpack_public_path__ + "static/img/logo-5-3.bf454c0f.png";